import * as Common from '@/agiles/common';
import { ModelBinder } from '../common/modelBinder';

export class Campaign extends Common.StateObject{
  constructor(){
    super('Campaign');
    this.state = CampaignStatus.pending;
    this.workflowStateId = CampaignStatus.pending;
    this.periodFrom = new Date().getCalendarDate();
    this.periodTo = new Date().getCalendarDate();
    this.periodTo.setDate(this.periodTo.getDate() + 30);
  }
  public id :number = 0;
  public name :string = '';
  public tenantFlag: CampaignTenantFlags = 0;
  public adminOnly : boolean = false;
  public isCampaign : boolean = true;
  public formGUID:string = '';
  public totalEntryLimit:number = 10000;
  public userEntryLimit:number = 1;
  public periodFrom :Date;
  public periodTo : Date;
  public totalCount :number = 0;
  public userCount:number = 0;
  public copy():any {
    const temp = super.copy() as Campaign;
    temp.id = 0;
　 temp.totalCount = 0;
    temp.userCount = 0;
    return temp;
  }    
}

export enum CampaignTenantFlags{
  default = 0,
  trial = 1,
  paid = 2
}

export enum CampaignStatus{
  pending = 1, 
  open = 2,
  closed = 4,
  notClosed = pending | open,
  all = pending | open | closed,
}

export class CampaignQuery extends Common.LoadQuery {
  constructor(){
    super('CampaignQuery',Campaign);
    this.sort = 'id';    
  }
  public name :string = '';
  public id:number = null;
  public state :CampaignStatus = CampaignStatus.notClosed;
}

export class CampaignMasterQuery extends Common.LoadQuery {
  constructor(){
    super('CampaignMasterQuery',Campaign);
  }
}

export class CampaignTenantQuery extends Common.Query {
  constructor(){
    super('CampaignTenantQuery',new ModelBinder(Common.Campaign,true));
  }  
}

export class Webhook extends Common.Query {
  constructor(){
    super('Webhook',null);
  }  
  public campaignId : string = null;
  public tenantid : string = null;
  public userId: string = '';
  public userName:string = '';  
}